import { getFile, objectToQueryParams } from '@si/utils';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

type Args = { filepath: string };

export function useDownloadDocumentation() {
  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ filepath }: Args) =>
      getFile({
        url: `/documentation/download${objectToQueryParams({ filepath })}`,
      }),
  });

  const downloadDocumentation = useCallback((params: Args) => mutate(params), [mutate]);

  return {
    downloadDocumentation,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
